import type { FC } from "react";

import { cn } from "@/lib/utils";

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
};
export const PopoverItem: FC<Props> = ({ children, onClick, className }) => {
  return (
    <>
      <div
        onClick={onClick}
        className={cn(
          "group flex cursor-pointer items-center gap-x-2 px-6 py-2 text-sm hover:bg-aubergine-perl-500 hover:text-dr-white-100",
          className,
        )}
      >
        {children}
      </div>
    </>
  );
};
